export default __webpack_public_path__ + "static/media/WhiteAddSchedule.52d568df.svg";